import React from "react";
import { Link } from "react-router-dom";
import { MARKETING_ZONES, ZONE_DETAILS } from "../lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-zinc-950 text-zinc-300 mt-20">
      <div className="bp-grid-dark">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5 mb-5">
              <img
                src="/warehousesuae-icon-white.png"
                alt="WarehousesUAE"
                className="w-11 h-11 object-contain"
                width="44"
                height="44"
              />
              <div>
                <div className="font-display text-white text-lg tracking-tighter">WAREHOUSESUAE<span className="text-[#FFCC00]">.COM</span></div>
                <div className="font-mono-tech text-[10px] text-zinc-500 uppercase">powered by Blueworld Realestate</div>
              </div>
            </div>
            <p className="text-sm text-zinc-400 max-w-sm leading-relaxed">
              Dubai&apos;s industrial real estate specialists. Warehouses, logistics, showrooms & industrial units
              across JAFZA, DIP, Al Quoz, Ras Al Khor, Dubai South, DIC, Al Warsan Industrial and the National Industrial Park (NIP).
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-tech text-[10px] text-zinc-500 uppercase mb-4">// PROPERTIES</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/properties?type=warehouse" className="hover:text-white">Warehouses</Link></li>
              <li><Link to="/properties?type=industrial_unit" className="hover:text-white">Industrial Units</Link></li>
              <li><Link to="/properties?type=storage" className="hover:text-white">Storage</Link></li>
              <li><Link to="/properties?type=showroom" className="hover:text-white">Showrooms</Link></li>
              <li><Link to="/properties?type=logistics" className="hover:text-white">Logistics</Link></li>
              <li><Link to="/market-analytics" data-testid="footer-market-link" className="hover:text-white">Market Analytics</Link></li>
              <li><Link to="/uae" data-testid="footer-uae-link" className="hover:text-white">Browse by Emirate</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono-tech text-[10px] text-zinc-500 uppercase mb-4">// ZONES</div>
            <ul className="space-y-2 text-sm">
              {MARKETING_ZONES.slice(0, 10).map((z) => (
                <li key={z}>
                  <Link to={`/zones/${ZONE_DETAILS[z].slug}`} className="hover:text-white">
                    {z}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-tech text-[10px] text-zinc-500 uppercase mb-4">// CONTACT</div>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between gap-4 border-b border-zinc-800 pb-2">
                <span className="text-zinc-500">PHONE</span>
                <a href="tel:+971588320669" className="font-mono-tech hover:text-white">+971 58 832 0669</a>
              </div>
              <div className="flex justify-between gap-4 border-b border-zinc-800 pb-2">
                <span className="text-zinc-500">WHATSAPP</span>
                <a href="https://wa.me/971588320669" className="font-mono-tech hover:text-[#25D366]">+971 58 832 0669</a>
              </div>
              <div className="flex justify-between gap-4 border-b border-zinc-800 pb-2">
                <span className="text-zinc-500">EMAIL</span>
                <a href="mailto:info@blueworldre.com" className="font-mono-tech hover:text-white">info@blueworldre.com</a>
              </div>
              <div className="flex justify-between gap-4 border-b border-zinc-800 pb-2">
                <span className="text-zinc-500">OFFICE</span>
                <span className="font-mono-tech text-right">Dubai Silicon Oasis, Office #304,<br />Donna Towers, Dubai</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-800">
          <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-zinc-500 font-mono-tech">
            <span>© {new Date().getFullYear()} WAREHOUSESUAE.COM — POWERED BY BLUEWORLD REALESTATE — RERA REGISTERED</span>
            <span data-testid="footer-designed-by">
              SITE DESIGNED BY{" "}
              <a
                href="https://strikecreatives.co"
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-300 hover:text-[#FFCC00] transition-colors"
              >
                STRIKECREATIVES.CO
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
